module.exports = __webpack_public_path__ + "img/selfie.aafd9ac0.jpeg";